<!-- 问卷列表 -->
<template>
  <div class="main">
    <div class="s_wrapper">
      <el-input class="s_input" v-model="questionnaireName" suffix-icon="el-icon-search" placeholder="搜索问卷名称" clearable
        @change="onSearch"></el-input>
      <el-select v-model="status" placeholder="选择上下架状态" @change="onSearch" clearable>
        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-date-picker v-model="datetime" type="datetimerange" range-separator="至" start-placeholder="开始时间"
        end-placeholder="结束时间" clearable @change="handleSelectData" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      <el-button class="btn" type="primary" @click="handleAdd">创建问卷</el-button>
    </div>
    <div class="g_table">
      <el-table :data="tableData" style="width: 100%" max-height="540">
        <el-table-column label="序号" show-overflow-tooltip width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column min-width="230" show-overflow-tooltip prop="questionnaireName" label="问卷名称"></el-table-column>
        <el-table-column min-width="190" show-overflow-tooltip prop="startTime" label="开始时间"></el-table-column>
        <el-table-column min-width="190" show-overflow-tooltip prop="endTime" label="结束时间"></el-table-column>
        <el-table-column min-width="190" show-overflow-tooltip prop="fillNumber" label="填写次数"></el-table-column>
        <el-table-column min-width="160" show-overflow-tooltip prop="questionnaireStatus" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.questionnaireStatus == 2">未开始</div>
            <div v-if="scope.row.questionnaireStatus == 1">进行中</div>
            <div v-if="scope.row.questionnaireStatus == 0">已结束</div>
          </template>
        </el-table-column>
        <el-table-column label="上下架" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.switch" active-color="" inactive-color="#E2E2E2"
              @change="changeStatus(scope.row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip label="操作" header-align="center" align="center" fixed="right"
          min-width="200">
          <template slot-scope="scope">
            <el-button type="primary" plain @click="handleCheck(scope.row)">查看详情</el-button>
            <el-button type="danger" plain @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr"
      layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      questionnaireName: "",
      questionCode: "",
      status: "",
      statusOptions: [
        {
          value: "1",
          label: "已上架",
        },
        {
          value: "0",
          label: "待上架",
        },
      ],
      datetime: [], //时间区间
      tableData: [], //表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      pageSizeArr: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount: 0, // 总记录数（需要从后端获取）
    }
  },
  created() {
    this.selectQuestionnaireInfoPage()
  },

  methods: {
    // 获取列表
    selectQuestionnaireInfoPage() {
      this.loading = true
      let params = {
        questionnaireName: this.questionnaireName || null,
        status: this.status || null,
        page: this.currentPage,
        pageSize: this.pageSize,
      }

      // 时间区间
      if (this.datetime && this.datetime.length === 2) {
        params.startTime = this.datetime[0]
        params.endTime = this.datetime[1]
      } else {
        params.startTime = null
        params.endTime = null
      }

      this.$axios
        .get(this.$api.selectQuestionnaireInfoPage, { params })
        .then(res => {
          if (res.code == 100) {
            this.tableData =
              res.result.list.map(e => {
                return {
                  ...e,
                  switch: e.status == 1 ? true : false,
                }
              }) || []
            this.totalItemsCount = res.result.totalCount
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 创建问卷
    handleAdd(row) {
      this.$router.push('/question/detail/apply')
    },
    // 查看
    handleCheck(row) {
      this.$router.push({ path: "/question/detail/questionDetail", query: { questionnaireId: row.questionnaireId, questionnaireName: row.questionnaireName, questionnaireIntroduce: row.questionnaireIntroduce } })
    },
    onSearch() {
      this.clearData()
      this.selectQuestionnaireInfoPage()
    },
    // 时间搜索
    handleSelectData(value) {
      this.datetime = value
      this.onSearch()
    },
    // 清空
    clearData() {
      this.tableData = []
      this.currentPage = 1
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.selectQuestionnaireInfoPage()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.selectQuestionnaireInfoPage()
    },
    // 切换上下架
    changeStatus(row) {
      const originalSwitch = row.switch
      this.$confirm(`确定${row.switch ? "上架" : "下架"}该问卷吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$axios
            .post(this.$api.updateQuestionnaireInfoStatus, {
              questionnaireIdList: [row.questionnaireId],
              status: row.switch ? 1 : 0,
            })
            .then(res => {
              this.$set(row, "switch", originalSwitch)
              this.$message.success(res.desc)
              this.selectQuestionnaireInfoPage()
            })
            .catch(err => {
              this.$set(row, "switch", !originalSwitch)
              this.$message.error(err.desc)
              this.selectQuestionnaireInfoPage()
            })
        })
        .catch(() => {
          this.$set(row, "switch", !originalSwitch)
          this.selectQuestionnaireInfoPage()
        })
    },
    handleDelete(row) {
      this.$confirm('请确认是否要删除？', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.$axios
          .get(this.$api.deleteQuestionnaireInfo, {
            params: {
              questionnaireId: row.questionnaireId,
            },
          })
          .then(res => {
            if (res.code == 100) {
              this.$message.success(res.desc)
              this.selectQuestionnaireInfoPage()
            }
          })
          .catch(err => {
            this.$message.error(err.desc)
          })
      })
    },
  },
}
</script>

<style scoped lang="scss">
.main {}
</style>
